import React from 'react';
import { IonButton, IonIcon } from '@ionic/react';

export interface ProEmptyStateProps {
  /** Ionicon name or a custom icon element (e.g. lucide-react). */
  icon: string | React.ReactNode;
  message: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

/**
 * Centered empty state for Pro list pages.
 */
const ProEmptyState: React.FC<ProEmptyStateProps> = ({
  icon,
  message,
  description,
  actionLabel,
  onAction,
  className = '',
}) => (
  <div className={`flex flex-col items-center justify-center py-20 text-center ${className}`.trim()}>
    {typeof icon === 'string' ? (
      <IonIcon
        icon={icon}
        className="text-5xl text-text-tertiary dark:text-text-dark-tertiary mb-3 opacity-40"
      />
    ) : (
      <div className="text-text-tertiary dark:text-text-dark-tertiary mb-3 opacity-40">{icon}</div>
    )}
    <p className="text-sm font-medium text-text-secondary dark:text-text-dark-secondary mb-1">
      {message}
    </p>
    {description && (
      <p className="text-xs text-text-tertiary dark:text-text-dark-tertiary max-w-xs">
        {description}
      </p>
    )}
    {actionLabel && onAction && (
      <IonButton fill="clear" size="small" onClick={onAction} className="mt-2">
        {actionLabel}
      </IonButton>
    )}
  </div>
);

export default ProEmptyState;
